import React, { Component } from 'react'
import { connect } from 'react-redux'
import { buyProduct, removeProduct } from '../actions'
import { Link } from 'react-router-dom'

class GroceryList extends Component {
  render() {
    return (
      <>
        {this.props.products.length > 0 ?
          (
            <ul>
              {this.props.products.map(product => (
                <li key={`product-${product.id}`}>
                  <label>
                    <input
                      type="checkbox"
                      checked={product.bought}
                      onChange={() => this.props.buyProduct(product.id)}
                    />
                    {product.name}
                  </label>
                  {product.brand &&
                    <p>Brand: {product.brand}</p>
                  }
                  <p>Quantity: {product.quantity}</p>
                  <Link to={`/update-product/${product.id}`}>Update product</Link>
                  <button onClick={() => this.props.removeProduct(product.id)}>
                    Remove product
                  </button>
                </li>
              ))}
            </ul>
          ) :
          (
            <p>No products on the list. You can add new products at the <Link to="/add-products">add products page</Link></p>
          )
        }
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    products: state.products
  }
}

export default connect(
  mapStateToProps,
  { buyProduct, removeProduct }
)(GroceryList);